import { useMedia } from 'use-media';

export const useIsMobile = () => useMedia('(max-width: 767px)');
